import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Hero from '../../static/img/events_page/master_hero.png';
import Img1 from '../../static/img/events_page/master_img1.png';
import Img2 from '../../static/img/events_page/master_img2.png';

const styles = theme => ({
  bottomMargin: {
    marginBottom: theme.spacing(3),
  },
  centeredText: {
    textAlign: 'center',
  },
});

function description(props) {
  const { classes } = props;
  return (
    <div className={classes.bottomMargin}>
      <Typography className={classes.bottomMargin} variant="body1">Come experience Nia magic in this exhilarating Master Class that will delve deep into this movement and lifestyle practice. As the first cardio workout to combine martial arts, dance, and healing arts, Nia has fundamentally changed lives with its evolutionary approach to fitness and self-healing.</Typography>
      <Typography className={classes.bottomMargin} variant="body1">Not to be missed, this hour long class will explore the profound magnificence of your body, the sacredness of your authentic self, and the heights of Joy of Movement.</Typography>
    </div>
  );
}

function paymentPolicy(props) {
  const { classes } = props;
  return (
    <div>
      <Typography className={classes.bottomMargin} variant="body1">The price of the Nia Black Belt Training is $1,599 (USD) plus tax where applicable. The fee for the training is split into two payments, a Registration Fee and an Instruction Fee. To reserve your spot in a training, you must pay a Registration Fee directly to Nia Technique, Inc. (via NiaNow&apos;s online registration system). The Trainer of your event will invoice you for the Instruction Fee and any applicable tax 30 days prior to the training start date. Based on the location of the event, the Trainer may invoice you in local currency at the current exchange rate with the USD.</Typography>
      <Typography className={classes.bottomMargin} variant="body1">All trainings will be confirmed 30 days prior to the event start date. Nia Technique recommends all customers wait to purchase any travel or accommodations until the event has been confirmed. </Typography>
    </div>
  );
}

function cancellationPolicy(props) {
  const { classes } = props;
  return (
    <div className={classes.bottomMargin}>
      <Typography className={classes.bottomMargin} variant="body1">Registration and instruction fees are non-refundable. Should you cancel your registration more than 30 days prior to the training start date, the registration fee will be credited to your Nia account. Should you cancel your registration less than 30 days prior to the training start date, you will incur a cancellation fee of $250 which will be deducted from your registration fee. The remaining balance will be credited to your Nia account.</Typography>
      <Typography className={classes.bottomMargin} variant="body1">The cancellation policy regarding your instruction fee varies by trainer. Please contact your trainer for more information.</Typography>
      <Typography className={classes.quoteAuthor} variant="body1">If you have paid for a training that is canceled by the trainer, you will receive a full refund.</Typography>
    </div>
  );
}


description.propTypes = {
  classes: PropTypes.object.isRequired,
};
paymentPolicy.propTypes = {
  classes: PropTypes.object.isRequired,
};
cancellationPolicy.propTypes = {
  classes: PropTypes.object.isRequired,
};

const Description = withStyles(styles)(description);
const PaymentPolicy = withStyles(styles)(paymentPolicy);
const CancellationPolicy = withStyles(styles)(cancellationPolicy);

const Event = {
  title: 'Master Class',
  quote: 'Make your life a masterpiece; imagine no limitations on what you can be, have, or do.',
  quoteAuthor: '– Brian Tracy',
  price: '? USD',
  eligibility: 'All Students Welcome',
  button: 'Find a Masterclass',
  hero: Hero,
  img1: Img1,
  img2: Img2,
  description: <Description />,
  paymentPolicy: <PaymentPolicy />,
  cancellationPolicy: <CancellationPolicy />,
};

export default Event;
